import { cloneDeep } from 'lodash-es';
import { makeAutoObservable, observable, runInAction } from 'mobx';

import { AdminUser } from '~hooks/admin/useUsersAdmin/models';
import { RoleItem } from '~hooks/useUsers/models';
import { RootStore } from '~store/RootStore';

class UserAdminStore {
  user: AdminUser = {} as AdminUser;
  userRoles: RoleItem[] = [];

  constructor(private readonly rootStore: RootStore) {
    makeAutoObservable(this, {
      user: observable,
      userRoles: observable,
    });
    this.rootStore = rootStore;
  }

  setUserRoles(userRoles: RoleItem[]) {
    runInAction(() => {
      this.userRoles = [...userRoles];
    });
  }

  setUser(user: AdminUser) {
    runInAction(() => {
      this.user = cloneDeep(user);
    });
  }
}

export default UserAdminStore;
